import { Payments } from "../components/dashboard/payments";
import { useUser } from "../hooks/useUser";

const Page = (props) => {
  const user = useUser();
  if (!user) {
    return (
      <div className="d-flex align-items-center justify-content-center  display-2" style={{ height: "calc(100% - 85px)" }}>
        <i className="fas fa-spinner fa-spin"></i>
      </div>
    );
  }
  return <Payments {...props} />;
};

export default Page;
